import { Box, styled } from "@mui/material";
import LoginForm from "../../components/forms/Login";
import { useAuth } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ImageBackground = styled(Box)({
  position: "relative",
  width: "100vw",
  height: "100vh",
  backgroundImage: `url('img/login-bg.jpg')`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});

export const Login = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/previsions");
    }
  }, [isAuthenticated, navigate]);

  return (
    <ImageBackground>
      <Box
        display="flex"
        alignItems="stretch"
        justifyContent="flex-start"
        height="100vh"
        width="100%"
      >
        <LoginForm />
      </Box>
    </ImageBackground>
  );
};
